<div>
  <mat-tab-group
    [selectedIndex]="activeIndex()"
    (selectedTabChange)="activeLinkChanged.emit(activeLinksList[$event.index].name)"
    [mat-stretch-tabs]="false" mat-align-tabs="center">
    @for (searchTab of activeLinksList; track searchTab.name) {
      <mat-tab
        [label]="searchTab.label + (resultsCount()?.[searchTab.name] !== null ? ' (' + resultsCount()?.[searchTab.name] + ')' : '')"
        class="tab-link"
      ></mat-tab>
    }
  </mat-tab-group>
  <div class="page-container">
    @if (getResults()?.length === 0) {
      <span class="no-data">No data to show</span>
    } @else if(getResults()){
    <sm-virtual-grid
      [cardTemplate]="
        activeLink() === searchPages.projects ? ProjectTemplate :
        activeLink() === searchPages.experiments ? ExperimentTemplate :
        activeLink() === searchPages.models ? ModelsTemplate :
        activeLink() === searchPages.openDatasets ? openDatasetTemplate :
        activeLink() === searchPages.pipelines ? PipelineTemplate :
        activeLink() === searchPages.reports ? ReportsTemplate :
       ProjectTemplate"
      [items]="getResults()"
      [cardHeight]="getCardHeight()"
      [showLoadMoreButton]="getResults().length < resultsCount()?.[activeLink()] && !loading()"
      (itemClicked)="projectClicked($event)"
      (loadMoreClicked)="loadMoreClicked.emit()"
    >
    </sm-virtual-grid>
    }
  </div>

  <ng-template #ProjectTemplate let-project>
    <sm-project-card
      [project]="project"
      (projectCardClicked)="projectClicked($event)"
      [hideMenu]="true"
    ></sm-project-card>
  </ng-template>

  <ng-template #ExperimentTemplate let-experiment>
    <sm-experiment-card
      [experiment]="experiment"
      (experimentCardClicked)="experimentClicked($event)"
    ></sm-experiment-card>
  </ng-template>

  <ng-template #ModelsTemplate let-model>
    <sm-model-card
      [model]="model"
      (modelCardClicked)="modelClicked($event)"
    ></sm-model-card>
  </ng-template>

  <ng-template #PipelineTemplate let-pipeline>
    <sm-pipeline-card
      [project]="pipeline"
      [hideMenu]="true"
      (projectCardClicked)="pipelineClicked($event)"
    ></sm-pipeline-card>
  </ng-template>

  <ng-template #openDatasetTemplate let-dataset>
    <sm-open-dataset-card
      [hideMenu]="true"
      [project]="dataset"
      (projectCardClicked)="openDatasetClicked($event)"
    ></sm-open-dataset-card>
  </ng-template>
  <ng-template #ReportsTemplate let-report>
    <sm-report-card
      [hideMenu]="true"
      [report]="report"
      (cardClicked)="reportClicked($event)"
    ></sm-report-card>
  </ng-template>
</div>
